import type { CreateProjectOptions, GitWorkspaceInfo, Result, ToolchainSetupProgress } from '@lved/shared-core/types';

export type CLIArgs = {
    projectPath?: string;
    renesasConfigPath?: string;
};

export type ProjectServiceOperation = 'generate' | 'compile' | 'clean';
export type ProjectServiceMessageBoxOptions = {
    type: 'info' | 'warning';
    buttons: string[];
    cancelId?: number;
    defaultId?: number;
    noLink?: boolean;
    title: string;
    message: string;
};
export type ProjectServiceEvent =
    | {
          type: 'started';
          operation: ProjectServiceOperation;
          projectPath: string;
          requestId?: string;
      }
    | {
          type: 'progress';
          operation: ProjectServiceOperation;
          projectPath: string;
          message: string;
          percent?: number;
          requestId?: string;
      }
    | {
          type: 'completed';
          operation: ProjectServiceOperation;
          projectPath: string;
          result: Result;
          requestId?: string;
      }
    | {
          type: 'failed';
          operation: ProjectServiceOperation;
          projectPath: string;
          message: string;
          requestId?: string;
      }
    | {
          type: 'toolchain-setup-progress';
          operation: ProjectServiceOperation;
          projectPath: string;
          progress: ToolchainSetupProgress;
          requestId?: string;
      };
export const TheiaProjectServicePath: string = '/services/theia-project-service';

export const ITheiaProjectServiceServer = Symbol('ITheiaProjectServiceServer');
export type ITheiaProjectServiceServer = {
    // The client is set after the connection is established, so need a method to set it.
    setClient(client?: ITheiaProjectServiceClient): void;

    // API methods
    getStartupCliArgs(): Promise<CLIArgs>;
    getResourcesSourcePath(): Promise<string>;
    getResourcesPath(): Promise<string>;
    createProject(projectPath: string, options: CreateProjectOptions): Promise<boolean>;
    isRenesasConfigDifferentFromProjectConfig(projectPath: string, renesasConfigPath: string): Promise<boolean>;
    updateProjectConfigFromRenesasConfig(projectPath: string, renesasConfigPath: string): Promise<boolean>;
    generateProjectCode(projectPath: string): Promise<Result>;
    compileProject(projectPath: string): Promise<Result>;
    cleanProject(projectPath: string): Promise<Result>;
    getGitRemotes(projectPath: string): Promise<GitWorkspaceInfo>;
    isGitInstalled(): Promise<boolean>;
};

export const ITheiaProjectServiceClient = Symbol('ITheiaProjectServiceClient');
export type ITheiaProjectServiceClient = {
    onProjectServiceEvent(event: ProjectServiceEvent): void;
    showProjectServiceMessageBox(options: ProjectServiceMessageBoxOptions): Promise<number>;
};
